module.exports = __webpack_public_path__ + "static/media/Badge-Rejected.e82975eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Badge-Rejected.png
// module id = 2456
// module chunks = 17